@import '../../scss/mixin';

.root {
  :global(.llm__row) {
    padding: 0 0 1rem 0;
  }
}

.anchor {
  background: #ccc;
  font-size: 13px;
  padding: 0.3em 0.6em;
  border-radius: 0.3em;
  display: inline-flex;
  align-items: center;
  gap: 0.4em;

  background: var(--llm-hint-background);
  color: var(--llm-hint-foreground);
  border: var(--llm-markdown-border);
  font-family: var(--llm-hint-font-family);
  box-shadow: var(--llm-hint-box-shadow);
  backdrop-filter: blur(20px);
}

.icon {
  width: 0.8em;
  height: 0.8em;
}
